// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "js/" + {"594":"about","597":"projects"}[chunkId] + "." + {"594":"7df5eb52","597":"0c661459"}[chunkId] + ".js";
};